// Copyright (c) BSS-ONE
// Author: Alexandru Bagu (a.bagu at software-dep.net)

<template>
  <div>
    <a-card class="breadcrumb-card">
      <a-row>
        <a-col :span="device === 'mobile' ? 24 : 12" style="padding-left: 12px">
          <breadcrumb :resource="computedWorkspace">
            <template v-slot:end>
              <span>
                <a-button
                  :loading="isLoading"
                  style="margin-bottom: 5px"
                  shape="round"
                  size="small"
                  @click="fetchData({ irefresh: true })">
                  <template #icon><sync-outlined /></template>
                  {{ $t('label.refresh') }}
                </a-button>
              </span>
            </template>
          </breadcrumb>
        </a-col>
        <a-col :span="device === 'mobile' ? 24 : 12" :gutter="12" class="text-right" v-if="isAnsibleEnabled == 1 && isWorkspacesEnabled == 1">
          <a-button v-if="this.workspace.status === 'READY' && this.workspace.broker === 'smartrtc'" @click="openWorkspaceManagement()" style="margin-right: 5px" type="primary">{{ this.$t("label.workspaces.manage") }}</a-button>
          <a-button v-if="this.workspace.status === 'READY'" @click="toggleAddUserModal()" style="margin-right: 5px">
            <plus-outlined />
            {{ this.$t("label.workspaces.user") }}
          </a-button>
          <a-button v-if="this.workspace.status === 'READY'" @click="toggleAddApplianceModal()" style="margin-right: 5px">
            <plus-outlined />
            {{ this.$t("label.workspaces.appliance") }}
          </a-button>
          <a-tooltip placement="bottom">
            <template v-slot:title><span>{{ this.$t('label.workspace.toggle.totp.desc') }}</span></template>
            <a-button v-if="this.workspace.status === 'READY' && this.workspace.broker === 'smartrtc'" @click="toggleTotpComponent()" style="margin-right: 5px">{{ this.$t("label.workspace.toggle.totp") }}</a-button>
          </a-tooltip>
          <a-tooltip placement="bottom">
            <template v-slot:title><span>{{ this.$t('label.workspace.update') }}</span></template>
            <a-button v-if="this.isAdmin && this.workspace.status === 'READY'" @click="updateComponents()" type="dashed" shape="round">
              <template #icon><sync-outlined /></template>
            </a-button>
          </a-tooltip>
        </a-col>
      </a-row>
    </a-card>
    <a-card class="page-header-index-wide" v-if="isAnsibleEnabled == 0 || isWorkspacesEnabled == 0" >
      <a-row :gutter="24">
        <a-col :xl="24" :gutter="12" v-if="isAnsibleEnabled == 0">
          Ansible Integration must be configured before Workspaces can be used.
        </a-col>
        <a-col :xl="24" :gutter="12" v-if="isAnsibleEnabled == 1 && isWorkspacesEnabled == 0">
          Workspaces is not configured yet.
          <ul>
            <li v-for="(val, index) in workspaceErrors" :key="index">
              {{ val }}
            </li>
          </ul>
        </a-col>
      </a-row>
    </a-card>
    <a-row v-else>
      <a-col :md="24" :xl="7" :gutter="24" style="padding-left: 6px; padding-right: 6px; margin-bottom: 12px;">
        <info-card :resource="computedWorkspace" :loading="isLoading">
          <template v-slot:details>
            <div class="resource-detail-item">
              <div class="resource-detail-item__label">{{ $t('label.url') }}</div>
              <div class="resource-detail-item__details">
                <a-icon type="home" style="margin-right: 10px" />
                <a :href="`https://${workspace.url}`">{{ workspace.url }}</a>
              </div>
            </div>
          </template>
        </info-card>
      </a-col>
      <a-col :md="24" :xl="17" style="padding-left: 6px; padding-right: 6px;">
        <a-card
          class="spin-content"
          :bordered="true"
          style="width:100%">
          <a-tabs
            style="width: 100%"
            :animated="false"
            :activeKey="activeTab || tabs[0].key"
            @change="onTabChange" >
            <a-tab-pane
              :tab="$t('label.' + tab.name)"
              v-for="tab in tabs"
              :key="tab.key"
              :loading="isLoading">
              <component
                :is="tab.component"
                :workspaceId="workspace.uuid"
                :tab="activeTab"
                @triggerRefresh="this.updateTabs"/>
            </a-tab-pane>
          </a-tabs>
        </a-card>
      </a-col>
    </a-row>
    <a-modal
      :title="this.$t('label.workspaces.user.add')"
      :visible="addUserModalVisible"
      :confirm-loading="addUserModalConfirmLoading"
      @ok="createUser"
      @cancel="addUserModalClose">
      <a-form
        :ref="(el) => { this.user_ref = el; }"
        :model="new_user"
        :rules="user_rules"
        layout="vertical">
        <a-row><a-col :xl="24">
          <a-form-item name='linkedappliance'>
            <label>
              <a-checkbox v-model:checked='new_user.linkedappliance' />
              {{ this.$t('label.create.linked.appliance') }}
            </label>
          </a-form-item>
        </a-col></a-row>
        <a-row><a-col :xl="24">
          <a-form-item :label="this.$t('label.firstname')" name='firstname'>
            <a-input v-model:value='new_user.firstname' />
          </a-form-item>
        </a-col></a-row>
        <a-row><a-col :xl="24">
          <a-form-item :label="this.$t('label.lastname')" name='lastname'>
            <a-input v-model:value='new_user.lastname' />
          </a-form-item>
        </a-col></a-row>
        <a-row><a-col :xl="24">
          <a-form-item :label="this.$t('label.username')" name='username'>
            <a-input v-model:value='new_user.username' />
          </a-form-item>
        </a-col></a-row>
        <a-row><a-col :xl="24">
          <a-form-item :label="this.$t('label.email')" name='email'>
            <a-input v-model:value='new_user.email' />
          </a-form-item>
        </a-col></a-row>
        <a-row><a-col :xl="24">
          <a-form-item :label="this.$t('label.password')" name='password'>
            <a-input v-model:value='new_user.password' type="password" />
          </a-form-item>
        </a-col></a-row>
        <a-row><a-col :xl="24">
          <a-form-item :label="this.$t('label.confirmpassword')" name='confirmpassword'>
            <a-input v-model:value='new_user.confirmpassword' type='password' />
          </a-form-item>
        </a-col></a-row>
      </a-form>
    </a-modal>
    <a-modal
      :title="this.$t('label.workspaces.appliance.add')"
      :visible="addApplianceModalVisible"
      :confirm-loading="addApplianceModalConfirmLoading"
      @ok="createAppliance"
      @cancel="addApplianceModalClose">
      <a-form
          :ref="(el) => { this.appliance_ref = el; }"
          :model="new_appliance"
          :rules="appliance_rules"
          layout="vertical">
        <a-row><a-col :xl="24">
          <div style="margin-top: 15px">
            <span>{{ $t('message.select.a.workspace.appliance.name') }}</span><br/>
            <a-form-item :label="this.$t('label.name')" name="name">
              <a-input v-model:value="new_appliance.name" />
            </a-form-item>
          </div>
        </a-col></a-row>
        <a-row><a-col :xl="24">
          <div style="margin-top: 15px">
            <span>{{ $t('message.select.a.workspace.appliance.template') }}</span><br/>
            <a-form-item :label="this.$t('label.templateid')" name="template_id">
              <a-select
                v-model:value="new_appliance.template_id"
                showSearch
                optionFilterProp="label"
                :filterOption="filterOption"
                :options="templateSelectOptions"
                @change="onSelectTemplateId"
              ></a-select>
            </a-form-item>
          </div>
        </a-col></a-row>
        <a-row><a-col :xl="24">
          <a-form-item :label="this.$t('label.username')" v-if="templateId !== null && !isSystemTemplate" name="username">
            <a-input v-model:value="new_appliance.username" />
          </a-form-item>
        </a-col></a-row>
        <a-row><a-col :xl="24">
          <a-form-item :label="this.$t('label.password')" v-if="templateId !== null && !isSystemTemplate" name="password">
            <a-input type="password" v-model:value="new_appliance.password" />
          </a-form-item>
        </a-col></a-row>
        <a-row><a-col :xl="24">
          <div style="margin-top: 15px">
            <span>{{ $t('message.select.a.workspace.appliance.serviceoffering') }}</span><br/>
            <a-form-item :label="this.$t('label.serviceofferingid')" name="service_offering_id">
              <a-select
                v-model:value="new_appliance.service_offering_id"
                showSearch
                optionFilterProp="label"
                :filterOption="filterOption"
                :options="computeSelectOptions"
                @change="onSelectComputeId"
              ></a-select>
            </a-form-item>
          </div>
        </a-col></a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { reactive } from 'vue'
import InfoCard from '@/components/view/InfoCard'
import Breadcrumb from '@/components/widgets/Breadcrumb'
import Status from '@/components/widgets/Status'
import { mixinDevice } from '@/utils/mixin.js'
import AnsibleMixin from './AnsibleMixin'
import WorkspaceAppliances from '@/views/plugins/workspaces/WorkspaceAppliances'
import WorkspaceUsers from '@/views/plugins/workspaces/WorkspaceUsers'

export default {
  name: 'ManageWorkspace',
  components: {
    InfoCard,
    Breadcrumb,
    Status
  },
  mixins: [mixinDevice, AnsibleMixin],
  props: {
    id: { type: String, default: () => null }
  },
  data () {
    return {
      addUserModalVisible: false,
      addUserModalConfirmLoading: false,
      addApplianceModalVisible: false,
      addApplianceModalConfirmLoading: false,
      new_user: null,
      user_ref: null,
      user_rules: null,
      new_appliance: null,
      appliance_ref: null,
      appliance_rules: null,
      isAdmin: false,
      isSystemTemplate: null,
      templateId: null,
      serviceOfferingId: null,
      templates: [],
      serviceOfferings: [],
      systemTemplate: {
        uuids: '',
        username: '',
        passsword: ''
      },

      manageUrl: '',
      workspace: { },
      refreshTrigger: { },
      network: { },
      template: { },
      serviceOffering: { },
      zone: { },
      serviceoffering: { },
      virtualmachines: [],
      isLoading: true,
      activeTab: 'users_0',
      tabs: [
        {
          name: 'users',
          key: 'users_0',
          keyId: 0,
          component: WorkspaceUsers
        },
        {
          name: 'appliances',
          key: 'appliances_0',
          keyId: 0,
          component: WorkspaceAppliances
        }
      ],

      isAnsibleEnabled: false,
      isWorkspacesEnabled: false,
      workspaceErrors: [],
      brokers: []
    }
  },
  computed: {
    templateSelectOptions () {
      return this.templates.filter((template) => {
        if (template.ostypename.indexOf('Windows') >= 0) {
          return true
        } else {
          return false
        }
      }).map((template) => {
        return {
          label: template.displaytext,
          value: template.id
        }
      })
    },
    computeSelectOptions () {
      return this.serviceOfferings.map((serviceOffering) => {
        return {
          label: `${serviceOffering.name} - ${serviceOffering.cpunumber}vCPU & ${this.humanReadableMemory(serviceOffering.memory)} RAM`,
          value: serviceOffering.id
        }
      })
    },
    computedWorkspace: function () {
      var workspace = JSON.parse(JSON.stringify(this.workspace))
      workspace.name = workspace.adDomain
      workspace.state = this.workspace.status || ''
      workspace.state = workspace.state.charAt(0).toUpperCase() + workspace.state.slice(1).toLowerCase()
      workspace.id = workspace.uuid
      workspace.type = this.getBrokerName(workspace.brokerType)
      workspace.sourceipaddressnetworkid = this.network.id
      workspace.sourceipaddressnetworkname = this.network.name
      workspace.vpcid = this.network.vpcid
      workspace.vpcname = this.network.vpcname
      workspace.templateid = this.template.id
      workspace.templatename = this.template.name
      workspace.zoneid = this.zone.id
      workspace.zonename = this.zone.name
      workspace.serviceofferingid = this.serviceoffering.id
      workspace.serviceofferingname = this.serviceoffering.name
      return workspace
    }
  },
  created () {
    this.isAdmin = this.isAdminRole()
    this.init_user_form()
    this.init_appliance_form()
  },
  async mounted () {
    await this.fetchData()
  },
  methods: {
    humanReadableMemory (megabytes) {
      var q = 'MB'
      if (megabytes >= 1024) {
        megabytes /= 1024
        q = 'GB'
      }
      return Math.round(megabytes * 10) / 10 + q
    },
    async fetchWorkspaceConfiguration () {
      var config = (await this.asyncApi('workspaceGetConfiguration')).workspaceconfigurationresponse.payload.configuration
      this.systemTemplate.uuids = config['workspaces.vdi_base_template_uuids']
      this.systemTemplate.username = config['workspaces.vdi_base_username']
      this.systemTemplate.password = config['workspaces.vdi_base_password']
    },
    async fetchTemplates () {
      const json = await this.asyncApi('listTemplates', { listall: true, templatefilter: 'executable', zoneid: this.workspace.zoneId })
      this.templates = json.listtemplatesresponse.template || []
    },
    async fetchServiceOfferings () {
      const json = await this.asyncApi('listServiceOfferings', { listall: true, zoneid: this.zoneId })
      this.serviceOfferings = json.listserviceofferingsresponse.serviceoffering || []
    },
    init_user_form () {
      this.new_user = reactive({
        linkedappliance: true,
        username: '',
        email: '',
        firstname: '',
        lastname: '',
        password: '',
        confirmpassword: ''
      })
      this.user_rules = reactive({
        firstname: [{ required: true, message: `${this.$t('message.error.firstname.required')}` }],
        lastname: [{ required: true, message: `${this.$t('message.error.lastname.required')}` }],
        username: [{ required: true, validator: this.validateUsername }],
        email: [{ required: true, validator: this.validateEmail }],
        password: [{ required: true, validator: this.validatePassword }],
        confirmpassword: [{ required: true, validator: this.validateConfirmPassword }]
      })
    },
    init_appliance_form () {
      this.new_appliance = reactive({
        name: '',
        template_id: '',
        username: '',
        password: '',
        service_offering_id: ''
      })
      this.appliance_rules = reactive({
        name: [{ required: true, message: `${this.$t('message.error.name.required')}` }],
        template_id: [{ required: true, message: `${this.$t('message.error.select')}` }],
        username: [{ required: true, validator: this.validateUsername }],
        password: [{ required: true }],
        service_offering_id: [{ required: true, message: `${this.$t('message.error.select')}` }]
      })
    },
    getBrokerName (type) {
      for (var i = 0; i < this.brokers.length; i++) {
        if (this.brokers[i].type === type) {
          return this.brokers[i].description
        }
      }
      return ''
    },
    async triggerChildRefresh () {
      var that = this
      var refreshTriggerRef = that.refreshTrigger

      let users = null
      if (this.workspace.uuid) {
        var json = await this.asyncApi('workspaceUserList', { workspace_uuid: this.workspace.uuid })
        users = json.workspaceuserlistresponse.payload.users
      }
      that.refreshTrigger = { refresh: true, users }

      setTimeout(() => { that.refreshTrigger = refreshTriggerRef })
    },
    async fetchData () {
      this.isLoading = true
      this.triggerChildRefresh()
      var ansibleStatus = this.asyncApi('ansibleStatus', {})
      var workspaceStatus = this.asyncApi('workspaceStatus', {})
      var fetchTemplates = this.fetchTemplates()
      var fetchServiceOfferings = this.fetchServiceOfferings()
      var fetchWorkspaceConfiguration = this.fetchWorkspaceConfiguration()

      let json = await ansibleStatus
      if (json) {
        this.isAnsibleEnabled = json.ansiblestatusresponse.payload.isEnabled
        json = await workspaceStatus
        if (json) {
          this.isWorkspacesEnabled = json.workspacestatusresponse.payload.enabled
          this.workspaceErrors = json.workspacestatusresponse.payload.errors
          this.brokers = json.workspacestatusresponse.payload.brokers
          if (this.isWorkspacesEnabled) {
            json = await this.asyncApi('workspaceGet', { uuid: this.$route.params.id })
            if (json) {
              this.workspace = json.workspaceresponse.payload.workspaces[0]
              var listNetworks = this.asyncApi('listNetworks', { id: this.workspace.networkId, listall: true })
              var listTemplates = this.asyncApi('listTemplates', { id: this.workspace.vdiTemplateId, listall: true, templatefilter: 'executable' })
              var listZones = this.asyncApi('listZones', { id: this.workspace.zoneId, listall: true })
              var listServiceOfferings = this.asyncApi('listServiceOfferings', { id: this.workspace.vdiServiceOfferingId, listall: true })
              var listVirtualMachines = this.asyncApi('listVirtualMachines', { listall: true, filter: 'id,name' })
              json = await listNetworks
              if (json) {
                this.network = json.listnetworksresponse.network[0]
              }
              json = await listTemplates
              if (json) {
                this.template = json.listtemplatesresponse.template[0]
              }
              json = await listZones
              if (json) {
                this.zone = json.listzonesresponse.zone[0]
              }
              json = await listServiceOfferings
              if (json) {
                this.serviceoffering = json.listserviceofferingsresponse.serviceoffering[0]
              }
              json = await listVirtualMachines
              if (json) {
                this.virtualmachines = json.listvirtualmachinesresponse.virtualmachine
              }
            }
          }
        }
      }
      await fetchTemplates
      await fetchServiceOfferings
      await fetchWorkspaceConfiguration
      this.isLoading = false
      this.updateTabs()
    },
    onTabChange (key) {
      this.activeTab = key
    },
    validateUsername (rule, value, callback) {
      var txt = value || ''
      for (var i = 0; i < txt.length; i++) {
        var c = txt.charAt(i)
        if (!((c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z') || (c >= '0' && c <= '9') || c === '_' || c === '.' || c === '-')) {
          callback(this.$t('error.invalid.windows.username.characters'))
          return
        }
      }
      if (!(txt.length >= 2 && txt.length <= 20)) {
        callback(this.$t('error.invalid.windows.username.length'))
        return
      }
      callback()
    },
    validateEmail (rule, value, callback) {
      var txt = value || ''
      // eslint-disable-next-line
      const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
      if (!re.test(String(txt).toLowerCase())) {
        callback(this.$t('error.invalid.email'))
        return
      }
      callback()
    },
    validatePassword (rule, value, callback) {
      var txt = value || ''
      var c = 0
      var C = 0
      var s = 0
      var d = 0
      for (var i = 0; i < txt.length; i++) {
        var chr = txt.charAt(i)
        if (chr >= 'a' && chr <= 'z') {
          c = 1
        } else if (chr >= 'A' && chr <= 'Z') {
          C = 1
        } else if (chr >= '0' && chr <= '9') {
          d = 1
        } else {
          s = 1
        }
      }

      if (txt.length < 6) {
        callback(this.$t('error.invalid.windows.password.length'))
        return
      }
      if (c + C + s + d < 4) {
        callback(this.$t('error.invalid.windows.password.strength'))
        return
      }
      callback()
    },
    validateConfirmPassword (rule, value, callback) {
      if (this.new_user.password !== value) {
        callback(this.$t('error.password.not.match'))
        return
      }
      callback()
    },
    async toggleTotpComponent () {
      var tempAnsibleParams = await this.getAnsibleBaseParams(this.workspace)

      var ansibleParams = this.convertNamespaces(tempAnsibleParams)
      var paramBase64 = this.encodeVars(ansibleParams)

      var ansibleTask = await this.asyncApi('ansibleStartTaskAsync', { playbook: 'toggle-workspace-broker-totp', vars: paramBase64 })
      await this.waitForTask(ansibleTask.ansiblestarttaskasyncresponse.jobid)
    },
    async updateComponents () {
      var tempAnsibleParams = await this.getAnsibleBaseParams(this.workspace)

      var ansibleParams = this.convertNamespaces(tempAnsibleParams)
      var paramBase64 = this.encodeVars(ansibleParams)

      var ansibleTask = await this.asyncApi('ansibleStartTaskAsync', { playbook: 'update-workspace-broker', vars: paramBase64 })
      await this.waitForTask(ansibleTask.ansiblestarttaskasyncresponse.jobid)
    },
    async createUser (e) {
      e.preventDefault()
      var that = this
      that.addModalConfirmLoading = true
      that.user_ref.validateFields().then(async () => {
        if (that.new_user.password !== that.new_user.confirmpassword) {
          that.$notification.error({ message: this.$t('error.password.not.match') })
        } else {
          var json = await that.asyncApi('workspaceUserRegister', {
            email: that.new_user.email,
            name: `${that.new_user.lastname} ${that.new_user.firstname}`,
            username: that.new_user.username,
            workspace_uuid: that.workspace.uuid
          })
          if (json && json.workspaceuserlistresponse && json.workspaceuserlistresponse.payload && json.workspaceuserlistresponse.payload.users && json.workspaceuserlistresponse.payload.users.length && json.workspaceuserlistresponse.payload.users[0]) {
            var user = json.workspaceuserlistresponse.payload.users[0]
            var registrationData = JSON.parse(JSON.stringify(that.new_user))
            that.addUserModalVisible = false
            that.init_user_form()
            that.fetchData()
            if (registrationData.linkedappliance) {
              await that.startVdiCreationProcess(user, registrationData)
            } else {
              await that.startUserCreationProcess(user, registrationData)
            }
            that.fetchData()
          } else {
            that.$notification.error({ message: that.$t('label.workspace.username_in_use') })
          }
        }
        that.addModalConfirmLoading = false
      }).catch(err => {
        that.addModalConfirmLoading = false
        that.user_ref.scrollToField(err.errorFields[0].name)
        if (err) {
          that.$notification.error({
            message: that.$t('message.request.failed'),
            description: that.$t('error.form.message')
          })
        }
      })
    },
    async startVdiCreationProcess (user, registrationData) {
      var tempAnsibleParams = await this.getAnsibleBaseParams(this.workspace)
      this.copyObject(user, tempAnsibleParams, 'user')
      tempAnsibleParams.user_password = registrationData.password
      tempAnsibleParams.user_firstname = registrationData.firstname
      tempAnsibleParams.user_lastname = registrationData.lastname
      tempAnsibleParams.user_name = `${registrationData.lastname} ${registrationData.firstname}`
      tempAnsibleParams.vdi_name = this.convertUsernameToVdiName(user.username)

      var ansibleParams = this.convertNamespaces(tempAnsibleParams)
      await this.getBestServiceOfferings(ansibleParams)
      var paramBase64 = this.encodeVars(ansibleParams)

      var ansibleTask = await this.asyncApi('ansibleStartTaskAsync', { playbook: 'setup-workspace-vdi', vars: paramBase64 })
      await this.waitForTask(ansibleTask.ansiblestarttaskasyncresponse.jobid, this.$t('label.workspace.vdi.start.setup'), this.$t('error.fetching.async.job.result'), this.$t('label.workspace.vdi.end.setup'))
    },
    async startUserCreationProcess (user, registrationData) {
      var tempAnsibleParams = await this.getAnsibleBaseParams(this.workspace)
      this.copyObject(user, tempAnsibleParams, 'user')
      tempAnsibleParams.user_password = registrationData.password
      tempAnsibleParams.user_firstname = registrationData.firstname
      tempAnsibleParams.user_lastname = registrationData.lastname
      tempAnsibleParams.user_name = `${registrationData.lastname} ${registrationData.firstname}`

      var ansibleParams = this.convertNamespaces(tempAnsibleParams)
      var paramBase64 = this.encodeVars(ansibleParams)

      var ansibleTask = await this.asyncApi('ansibleStartTaskAsync', { playbook: 'setup-workspace-user', vars: paramBase64 })
      await this.waitForTask(ansibleTask.ansiblestarttaskasyncresponse.jobid, this.$t('label.workspace.user.start.setup'), this.$t('error.fetching.async.job.result'), this.$t('label.workspace.user.end.setup'))
    },
    convertUsernameToVdiName (inName) {
      var name = ''
      for (var i = 0; i < inName.length; i++) {
        var c = inName[i]
        if ((c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z') || (c >= '0' && c <= '9') || c === '-') {
          name = name + c
        } else {
          name = name + '-'
        }
      }
      while (name[name.length - 1] === '-') {
        name = name.substr(0, name.length - 1)
      }
      if (name.length > 11) {
        name = name.substr(0, 11)
      }
      return name
    },
    toggleAddUserModal () {
      this.addUserModalVisible = true
    },
    addUserModalClose () {
      this.addUserModalVisible = false
    },
    async openWorkspaceManagement () {
      if (this.workspace.brokerType === 'smartrtc') {
        var workspaceappliancelistresponse = (await this.asyncApi('workspaceApplianceList', { workspace_uuid: this.workspace.uuid })).workspaceappliancelistresponse
        var appliances = workspaceappliancelistresponse.payload.appliances
        for (var i in appliances) {
          var appliance = appliances[i]
          if (appliance.type === 'ad-server') {
            window.open(`https://${this.workspace.url}#/?username=${appliance.username}&password=${appliance.password}`, '_blank')
          }
        }
      }
    },
    toggleAddApplianceModal () {
      this.addApplianceModalVisible = true
    },
    addApplianceModalClose () {
      this.addApplianceModalVisible = false
    },
    async startApplianceCreationProcess (applianceData) {
      var tempAnsibleParams = await this.getAnsibleBaseParams(this.workspace)
      applianceData.name = this.convertUsernameToVdiName(applianceData.name)
      if (!applianceData.username) {
        applianceData.username = tempAnsibleParams['workspace.vdi.admin.username']
        applianceData.password = tempAnsibleParams['workspace.vdi.admin.password']
      }
      this.copyObject(applianceData, tempAnsibleParams, 'appliance')

      var ansibleParams = this.convertNamespaces(tempAnsibleParams)
      await this.getBestServiceOfferings(ansibleParams)
      var paramBase64 = this.encodeVars(ansibleParams)

      var ansibleTask = await this.asyncApi('ansibleStartTaskAsync', { playbook: 'setup-workspace-appliance', vars: paramBase64 })
      await this.waitForTask(ansibleTask.ansiblestarttaskasyncresponse.jobid, this.$t('label.workspace.appliance.start.setup'), this.$t('error.fetching.async.job.result'), this.$t('label.workspace.appliance.end.setup'))
    },
    async createAppliance (e) {
      e.preventDefault()
      var that = this
      that.addApplianceModalConfirmLoading = true
      that.appliance_ref.validateFields().then(async () => {
        var registrationData = JSON.parse(JSON.stringify(that.new_appliance))
        that.addApplianceModalVisible = false
        that.init_appliance_form()
        await this.startApplianceCreationProcess(registrationData)
      }).catch(err => {
        that.addApplianceModalVisible = false
        that.appliance_ref.scrollToField(err.errorFields[0].name)
        if (err) {
          that.$notification.error({
            message: that.$t('message.request.failed'),
            description: that.$t('error.form.message')
          })
        }
      })
      that.addApplianceModalConfirmLoading = false
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toUpperCase().indexOf(input.toUpperCase()) >= 0
      )
    },
    async onSelectTemplateId (value) {
      this.templateId = value
      var templates = this.templates.filter((template, idx) => {
        return template.id === value
      })
      if (templates && templates.length) {
        this.template = templates[0]
        this.isSystemTemplate = this.systemTemplate.uuids.indexOf(value) >= 0
      } else {
        this.template = null
        this.templateId = null
      }
    },
    async onSelectComputeId (value) {
      this.serviceOfferingId = value
      var serviceOfferings = this.serviceOfferings.filter((offering, idx) => {
        return offering.id === value
      })
      if (serviceOfferings && serviceOfferings.length) {
        this.serviceOffering = serviceOfferings[0]
      } else {
        this.serviceOffering = null
        this.serviceOfferingId = null
      }
    },
    updateTabs () {
      for (var i = 0; i < this.tabs.length; i++) {
        var tab = this.tabs[i]
        tab.keyId = tab.keyId + 1
        var newKey = tab.name + '_' + tab.keyId
        if (this.activeTab === tab.key) {
          this.activeTab = newKey
        }
        tab.key = newKey
      }
    }
  }
}
</script>

<style scoped>
  .breadcrumb-card {
    margin-left: -24px;
    margin-right: -24px;
    margin-top: -16px;
    margin-bottom: 12px;
  }
  .row-element {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .ant-breadcrumb {
    vertical-align: text-bottom;
  }
  .padding-btns button {
    margin-left: 6px;
    margin-right: 6px;
  }
  .resource-detail-item__label {
    margin-bottom: 5px;
    font-weight: bold;
  }
</style>
